const value = {
    goToLearning: 'Перейти в Знания',
    team: 'Команда',
    noSuitableUnits: 'Нет подходящих юнитов',
    textFiled: 'Текстовое поле',
    pickValue: 'Выбор значения',
    edithCategoryWithValuePick: 'Редактирование категории с выбором значения',
    edithCategoryWithFieldText: 'Редактирование категории с текстовым полем',
    activeCategory: 'Активна',
    requiredCategory: 'Обязательна к заполнению',
    defaultValues: 'Значение по умолчанию',
    singleChoiceOnly: 'С выбором только одного ответа',
    imageIsTooSmall: 'Изображение слишком маленькое. Минимальный размер изображения 600 x 500 px.',
    passing: 'Прохождение',
    userRating: 'Рейтинг пользователя',
    learninAnalytics: 'Аналитика Обучение',
    editUnit: 'Редактирование юнита',
    projectPage: 'Страница проекта',
    systems: 'Мои системы',
    systemPage: 'Страница системы',
    asRequirements: 'Требование для АС',
    addCategory: 'Создать категорию',
    addValue: 'Создать значение',
    performerType: 'Тип исполнителей',
    activeDirectoryServers: 'Active Directory сервера',
    editActiveDirectory: 'Редактировать Active Directory',
    addActiveDirectory: 'Создать Active Directory',
    editUser: 'Редактировать пользователя',
    addUser: 'Создать пользователя',
    usersManagement: 'Управление пользователями',
    projectRoles: 'Проектные роли',
    systemRoles: 'Системные роли',
    addProjectRole: 'Создать проектную роль',
    editProjectRole: 'Редактировать проектную роль',
    addTemplate: 'Создать шаблон',
    editTemplate: 'Редактировать шаблон',
    addSystemRole: 'Создать системную роль',
    editSystemRole: 'Редактировать системную роль',
    templates: 'Шаблоны анкет',
    logging: 'Журналирование',
    automatizationSystem: 'АС',
    profileAS: 'Анкета АС',
    format: 'формат',
    competencyMap: 'Карта компетенции',
    teamCompetencyMap: 'Карта компетенций команды',
    trainingNotSetYet: 'Обучение не назначено',
    rename: 'Переименовать',
    noTrainingForThisSystem: 'Для этой системы обучение не предусмотрено, проверь обязательные юниты на вкладке знания',
    noMandatoryUnitsForTheRole: 'У ролей отсутствуют обязательные юниты',
    assignUnitsMessage: 'Рекомендуем назначить обязательные юниты в настройках проектных ролей',
    setupProjectRoles: 'Настроить проектные роли',
    profileCharacteristicsErrorMessage1: 'Характеристики анкеты не пересекаются с характеристиками обязательных юнитов',
    profileCharacteristicsErrorMessage2: 'В анкете нет характеристик из обязательных юнитов для проектных ролей',
    fillOutTheProfile: 'Заполнить анкету',
    createCopy: 'Создать копию',
    newFile: 'Новый файл',
    fileName: 'Название файла',
    folderName: 'Название папки',
    emptyFileValidationError: 'Значение не может быть пустым',
    newFolder: 'Новая папка',
    settings: 'Настройки',
    selectType: 'Выберите тип',
    comment: 'Пояснение',
    project: 'Проект',
    mandatory: 'Обязательные',
    optional: 'Необязательные',
    publish: 'Опубликовать',
    published: 'Опубликован',
    unpublish: 'Снять с публикации',
    edit: 'Редактировать',
    delete: 'Удалить',
    junior: 'Новичок',
    middle: 'Мидл',
    champion: 'Чемпион',
    jiraFields: 'Jira поля',
    total: 'Всего',
    never: 'Никогда',
    yesterday: 'Вчера',
    ago: 'Назад',
    minuteAgo: 'Минуту назад',
    now: 'Сейчас',
    searchTable: 'Поиск по таблице',
    toLearning: 'К знаниям',
    theory: 'Теория',
    quiz: 'Квиз',
    practice: 'Практика',
    min: 'Мин',
    task: 'Задача',
    question: 'Вопрос',
    questions: 'Вопросы',
    check: 'Проверить',
    retakeIn: 'Пересдать через',
    failedToLoadUnitResults: 'Не удалось загрузить результаты юнита',
    failedToFinishUnitResults: 'Не удалось завершить юнит',
    choosePracticeLang: 'Выберите язык для прохождения практики',
    chooseTheLang: 'Выберите язык',
    langSelection: 'Выбор языка',
    fold: 'Свернуть',
    expand: 'Развернуть',
    of: 'Из',
    completeUnit: 'Завершить юнит',
    quit: 'Выход',
    results: 'Результаты',
    correctAnswer: 'Вы ответили правильно',
    wrongAnswer: 'Вы ответили неправильно',
    title: 'Заголовок',
    subtitle: 'Подзаголовок',
    users: 'Пользователи',
    learning: 'Знания',
    add: 'Создать',
    cancel: 'Отменить',
    save: 'Сохранить',
    confirmDeleteRecord: 'Удалить запись?',
    confirmDeleteRecordLabel: 'Вы уверены, что хотите удалить запись?',
    yes: 'Да',
    addRole: 'Добавить Роль',
    units: 'Юниты',
    rights: 'Права',
    description: 'Описание',
    name: 'Имя',
    nameTitle: 'Название',
    user: 'Пользователь',
    fromWhatDate: 'С какой даты',
    toWhatDate: 'По какую дату',
    events: 'События',
    realizationStatus: 'Статус реализации',
    event: 'Событие',
    idEvents: 'ID события',
    timeEvents: 'Время события',
    text: 'Текст',
    dns: 'DNS',
    ip: 'IP',
    actions: 'Действия',
    admin: 'Администратор',
    exclude: 'Исключить',
    include: 'Включить',
    saveDraft: 'В черновик',
    preview: 'Предпросмотр',
    systemRole: 'Системная роль',
    notifications: 'Уведомления',
    reading: 'Чтение',
    creating: 'Создание',
    updating: 'Обновление',
    deleting: 'Удаление',
    verification: 'Верификация',
    sync: 'Синхронизировать',
    lastSynchronization: 'Последняя синхронизация',
    integrations: 'Интеграции',
    activeDirectory: 'Active Directory',
    login: 'Логин',
    password: 'Пароль',
    confirmPassword: 'Подтверждение пароля',
    userGroup: 'Группа пользователей',
    projectUser: 'Пользователи проекта',
    backToProject: 'К проекту',
    backToSettings: 'К настройкам',
    editProject: 'Редактировать проект',
    addProject: 'Добавить проект',
    addSystem: 'Добавить систему',
    integratedWithTheSystem: 'Объединено с Системой',
    youDoNotHavePermissionsToCreateSystems: 'У вас нет прав для создания систем. Обратитесь к администратору',
    fieldShouldContainNameOfProject: 'Данное поле должно содержать полное название Проекта',
    fieldShouldContainUniqueIdentifierOfProject:
      'Данное поле должно содержать уникальный идентификатор проекта в организации. В случае отсутствия кода указывается “Отсутствует“',
    jiraLink: 'Ссылка в JIRA',
    jiraLinkDescription: 'Ссылка на страницу данного продукта в Jira',
    anyAdditionalProjectInformation: 'Любая дополнительная информация по проекту',
    nameOfUnit: 'Название юнита',
    specifications: 'Значение',
    recommendedForRoles: 'Рекомендовано для ролей',
    unitCover: 'Обложка юнита',
    imageDiagram: 'Схема изображения',
    system: 'Система',
    single: 'Один',
    one: 'Один',
    multi: 'Мульти',
    langNotChosen: 'Язык не выбран',
    doNotRandomize: 'Не рандомизировать',
    answers: 'Ответы',
    addAnswer: 'Добавить ответ',
    correct: 'Верный',
    minutes: 'Минуты',
    reward: 'Награда',
    award: 'Награда',
    languages: 'Языки',
    type: 'Тип',
    resetChanges: 'Сбросить все изменения',
    notAdded: 'Не добавлено',
    linkFor: 'Для',
    for: 'для',
    invitationLinks: 'Ссылки-приглашения',
    deleteInvitationLinksHelper: 'Удалите ссылку и новые пользователи не смогут вступить по ней в проект',
    newInvitationLink: 'Новая ссылка',
    copiedToClipboard: 'Скопировано',
    isMarkedForDeleteHelper: 'Ссылка удалена',
    mustChangePasswordAfterLogin: 'Запросить смену пароля',
  };

export default value;
